import React, { FunctionComponent } from 'react';

import { VipAccountManagerLink_viewer$key } from './__generated__/VipAccountManagerLink_viewer.graphql';

const VipAccountManagerLink = React.lazy(() =>
    import(/* webpackChunkName: "VipAccountManagerLink" */ './VipAccountManagerLink')
);

type ComponentProps = {
    isClient: boolean;
    hasRootPendingRefetch?: boolean;
    hasUserId?: boolean;
    userId: string;
    userIds?: string[];
    viewer: VipAccountManagerLink_viewer$key;
};

export const VipAccountManagerLinkLazy: FunctionComponent<ComponentProps | null> = ({
    isClient,
    hasRootPendingRefetch,
    hasUserId,
    userId,
    userIds,
    viewer,
}) => {
    return isClient ? (
        <React.Suspense fallback="">
            <VipAccountManagerLink
                hasRootPendingRefetch={hasRootPendingRefetch}
                hasUserId={hasUserId}
                userIds={userIds}
                viewer={viewer}
                userId={userId}
            />
        </React.Suspense>
    ) : null;
};
